<template>
  <Modal id="updateProductModal">
    <template #header>
      <h5 class="modal-title">{{ $t('key_edit') }} {{ $t('key_theader_product') }}</h5>
    </template>
    <template #body>
      <form ref="updateProductForm" class="needs-validation" novalidate>
        <div class="row">
          <div class="col-12 col-sm-6">
            <label class="text-primary">{{ $t('key_title_ean') }} <span style="color:red">*</span> </label>
            <input v-model="editProduct.ean" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_ean')" required @blur="lookupProductByEan"/>
            <div v-if="eanNotFound" class="text-danger text-xs mt-1">{{ $t('key_mmessage_product_not_found') }}</div>
          </div>
          <div class="mt-3 col-12 col-sm-6 mt-sm-0">
            <label class="text-primary">{{ $t('key_title_product_name') }} <span style="color:red">*</span> </label>
            <input v-model="editProduct.name" class="form-control" type="text" maxLength="100" :placeholder="$t('key_placeholder_product_name')" disabled required/>
          </div>
        </div>
        <div class="row">
          <div class="mt-3 col-12 col-sm-6">
            <label class="text-primary">{{ $t('key_title_unit_price') }} <span style="color:red">*</span> </label>
            <input v-model.number="editProduct.price" class="form-control" type="number" min="0" step="0.01" :placeholder="$t('key_placeholder_unit_price')" required/>
          </div>
          <div class="mt-3 col-12 col-sm-6">
            <label class="text-primary">{{ $t('key_title_units') }} <span style="color:red">*</span> </label>
            <input v-model.number="editProduct.units.requested" class="form-control" type="number" min="1" :placeholder="$t('key_placeholder_units')" required/>
          </div>
        </div>
        <div class="row">
          <div class="mt-3 col-12">
            <label class="text-primary">{{ $t('key_title_warehouse') }} <span style="color:red">*</span> </label>
            <hk-select v-model="editProduct.warehouse" :placeholder="$t('key_placeholder_warehouse')" :options="warehouseOptions" required></hk-select>
          </div>
        </div>
        <div class="row">
          <div class="mt-3 col-12 col-sm-6">
            <label class="text-primary">{{ $t('key_title_batch') }}</label>
            <input v-model="editProduct.batch" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_batch')"/>
          </div>
          <div class="mt-3 col-12 col-sm-6">
            <label class="text-primary">{{ $t('key_title_batch_date') }}</label>
            <input v-model="editProduct.batch_date" class="form-control" type="date"/>
          </div>
        </div>
      </form>
    </template>
    <template #footer>
      <button ref="closeButton" type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">
        {{ $t('key_cancel') }}
      </button>
      <button type="button" class="btn bg-gradient-primary" @click="save">
        {{ $t('key_button_save') }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/ModalHotakauth.vue";
import HkSelect from "@/hotaka/components/HkSelect.vue";
import { taxRate } from "@/globalVars";

export default {
  name: "UpdateProductModal",
  components: { Modal, HkSelect },
  props: {
    product: { type: Object, default: () => ({}) },
    index: { type: Number, default: -1 },
    warehouseOptions: { type: Array, default: () => [] }
  },
  emits: ['product-updated'],
  data() {
    return {
      editProduct: this.emptyProduct(),
      eanNotFound: false
    }
  },
  computed: {
    productByEan() {
      return this.$store.state.products.productByEan.data;
    }
  },
  watch: {
    product(val) {
      const empty = this.emptyProduct();
      this.editProduct = {
        ...empty,
        ...val,
        units: { ...empty.units, ...(val.units || {}) },
        // The back stores lot dates as YYYY-MM-DD, the date input's own format.
        batch_date: this.$dateUtils.batchDateToInputValue(val.batch_date)
      };
      this.eanNotFound = false;
      let form = this.$refs.updateProductForm;
      if (form) form.classList.remove('was-validated');
    },
    productByEan(value) {
      if (value && value.items && value.items.length > 0) {
        this.editProduct.name = value.items[0].name;
        this.eanNotFound = false;
      } else {
        this.editProduct.name = '';
        this.eanNotFound = true;
      }
    }
  },
  methods: {
    emptyProduct() {
      return {
        name: '',
        ean: '',
        price: null,
        units: { requested: 1, booked: 0, completed: 0 },
        warehouse: '',
        batch: '',
        batch_date: ''
      };
    },
    lookupProductByEan() {
      if (!this.editProduct.ean) {
        this.editProduct.name = '';
        this.eanNotFound = false;
        return;
      }
      this.$store.commit('products/getByEan', this.editProduct.ean);
    },
    save() {
      let form = this.$refs.updateProductForm;
      if (!this.editProduct.name) {
        this.eanNotFound = true;
      }
      if (form.checkValidity() && this.editProduct.name) {
        const amount = this.editProduct.price * this.editProduct.units.requested;
        const tax = Math.round(amount * taxRate * 100) / 100;
        const total = Math.round((amount + tax) * 100) / 100;
        this.$emit('product-updated', {
          index: this.index,
          product: {
            ...this.editProduct,
            units: { ...this.editProduct.units },
            tax,
            amount,
            total
          }
        });
        this.hideModal();
      }
      form.classList.add('was-validated');
    },
    hideModal() {
      let button = this.$refs.closeButton;
      if (button) button.click()
    },
  },
};
</script>
